<template>
  <v-combobox
    outlined
    hide-details
    dense
    :disabled="disabled"
    :value="value"
    :items="items"
    :search-input.sync="searchInput"
    :auto-select-first="false"
    :placeholder="placeholder"
    append-icon=""
    @input="onInput"
    @blur="onBlur"
  />
</template>

<script>
export default {
  props: {
    value: String,
    disabled: Boolean,
    items: Array,
    placeholder: String,
  },
  data() {
    return {
      searchInput: "",
      syncingSearchInput: false,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(nextValue) {
        const normalized = this.normalizeValue(nextValue);
        if (normalized === this.searchInput) return;
        this.syncingSearchInput = true;
        this.searchInput = normalized;
        this.$nextTick(() => {
          this.syncingSearchInput = false;
        });
      },
    },
  },
  methods: {
    normalizeValue(value) {
      if (value == null) return "";
      if (typeof value === "object") {
        return String(value.text || value.value || value.label || "").trim();
      }
      return String(value).trim();
    },
    onInput(value) {
      const next = this.normalizeValue(value);
      this.syncingSearchInput = true;
      this.searchInput = next;
      this.$nextTick(() => {
        this.syncingSearchInput = false;
      });
      this.$emit("input", next);
    },
    onBlur() {
      const typed = this.normalizeValue(this.searchInput);
      if (typed !== this.normalizeValue(this.value)) {
        this.$emit("input", typed);
      }
    },
  },
};
</script>
